import { MouseEvent, useState } from 'react';
import { useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';

import { CustomAlert, CustomButton, Text } from '../../../../../shared/uiComponents';
import { errorNormalizer } from '../../../../../shared/Helpers/functions';
import { TrashEmpty } from '../../../../../shared/Assets/sessionDetailsSVGs';
import { RED } from '../../../../../shared/Helpers/colors';

import { DispatchProperties, useSelector } from '../../../../../redux/store';
import { deleteSkillArea, getSkillAreas } from '../../../../../redux/State/clientSlice/skillAreaSlice';
import { SkillProperties } from '../../../../../redux/API/ClientAPIHelpers/skillAreaProperties';
import { ButtonWrapper } from '../../../../../components/StyledComponents';

const Delete = ({ item }: { item: SkillProperties }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const isDeleting = useSelector((state) => state.skillArea.isDeleting);
	const [open, setOpen] = useState<boolean>(false);

	const onDeleteClick = (event: MouseEvent<HTMLDivElement>) => {
		event.stopPropagation();
		setOpen(true);
	};

	const deleteSkillAreaHandler = () => {
		const { clientId, id } = item;

		if (!clientId || !id) return;

		dispatch(deleteSkillArea({ clientId, id }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getSkillAreas({ clientId, funderId: item.funderId }));
				setOpen(false);
			})
			.catch(errorNormalizer);
	};

	return (
		<>
			<div className="actionRow" onClick={onDeleteClick}>
				<div className="actionIcon">
					<TrashEmpty color={RED.BASE} />
				</div>
				<div className="actionContent">
					<Text title="Delete" type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				isBusy={isDeleting}
				open={open}
				onClose={() => setOpen(false)}
				title="Do you want to delete the selected skill area?"
				Content={() => (
					<ButtonWrapper isInModal>
						<CustomButton title="Yes" className="marginRight8" onClick={deleteSkillAreaHandler} disabled={isDeleting} />
						<CustomButton title="No" buttonType="secondaryGray" onClick={() => setOpen(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default Delete;
